import type OrderPosition   from '@/domains/Orders/OrderPosition';
import type Receipt         from "@/domains/Receipts/Receipt";
import type ReceiptPosition from "@/domains/Receipts/ReceiptPosition";
import Title_ru_RU          from '@/core/misc/decorators/Title_ru_RU';
import SerializeSimplified  from "@/core/misc/decorators/SerializeSimplified";
import NoSerialize          from "@/core/misc/decorators/NoSerialize";
import TYPES                from '@/core/services/Changelogs/types';
import ComplaintType        from '@/domains/ComplaintType/ComplaintType';
import Serializable         from "@/core/misc/mixins/Serializable";
import Core                 from "@/core/Core";
import Qty                  from "@/core/types/Qty";


/**
 * Расхождение по позиции приемки
 */
export class ReceiptComplaintPosition extends Serializable {

  public id: number;

  @Title_ru_RU('Количество расхождения', TYPES.NUMBER)
  public qty: Qty;

  @Title_ru_RU('Тип расхождения', TYPES.OBJECT)
  @SerializeSimplified
  public type: ComplaintType | null;

  @NoSerialize
  public receipt: Receipt | { id: number } | null;
  @SerializeSimplified
  public receiptPosition: ReceiptPosition | { id: number } | null;
  @SerializeSimplified
  public orderPosition: OrderPosition | { id: number };

  /**
   * Создаёт новую претензию для указанной позиции заказа.
   * receipt и receiptPosition бэк проставит сам при сохранении.
   */
  static fromOrderPosition(orderPosition: OrderPosition): ReceiptComplaintPosition {
    const complaint = new ReceiptComplaintPosition();

    complaint.qty = Qty.zero();
    complaint.orderPosition = orderPosition;

    return complaint;
  }

  /**
   * Создаёт претензию конкретного типа с заданным количеством.
   */
  static fromComplaintType(orderPosition: OrderPosition, type: ComplaintType, qty: Qty): ReceiptComplaintPosition {
    const complaint = ReceiptComplaintPosition.fromOrderPosition(orderPosition);

    complaint.qty  = qty;
    complaint.type = type;

    return complaint;
  }

  static fromServer(data: any, complaint: ReceiptComplaintPosition = new ReceiptComplaintPosition()): ReceiptComplaintPosition {
    super.fromServer(data, complaint);

    complaint.qty = Core.utils.hydrate(data.qty, Qty.fromServer)!;
    complaint.type = Core.utils.hydrate(data.type, ComplaintType.fromServer);

    return complaint;
  }
}

export default ReceiptComplaintPosition;
